import { render, staticRenderFns } from "./DLTBMasterCard.vue?vue&type=template&id=54904d7c&scoped=true"
import script from "./DLTBMasterCard.vue?vue&type=script&lang=js"
export * from "./DLTBMasterCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54904d7c",
  null
  
)

export default component.exports